import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "DepartamentoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "DepartamentoPage",
            ss: ss,
            ajax: {
                "url": ss.indexDepartamento(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'Departamento', name: 'Departamento', title: 'Departamento' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            // unidadAcademicas: [],
            departamento: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newDepartamento() {
            this.departamento = {};
            this.$refs['frm-departamento'].show();
        },
        showDepartamento(id) {
            console.log("show");
            
            this.isLoading=true;
            this.ss.showDepartamento(id).then(
                (result) => {
                    let response = result.data;
                    this.departamento = response.data;
                    this.$refs['view-departamento'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editDepartamento() {
            this.$refs['frm-departamento'].show();
            this.$refs['view-departamento'].hide();
        },
        cancelDepartamento() {
            if (this.departamento.id) {
                this.$refs['view-departamento'].show();
            }
            this.$refs['frm-departamento'].hide();
        },
        saveDepartamento() {
            this.ss.storeDepartamento(this.departamento).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-departamento'].hide();
                    this.$refs['datatable-departamento'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        destroyDepartamento() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyDepartamento(this.departamento)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-departamento'].hide();
                                this.$refs['datatable-departamento'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Departamento').on('click', (evt) => {
                console.log("evento click");
                const data = window.$(evt.target)[0].id;
                this.showDepartamento(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
